import { IIconProps } from "@/components/icons/interface";

const LinkIcon = ({ width, height, color }: IIconProps) => {
  const strokeColor = color || "currentColor";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? 18}
      height={height ?? 18}
      viewBox="0 0 24 24"
      fill="none"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-link-icon lucide-link"
    >
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </svg>
  );
};

export { LinkIcon };
